var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg0Azul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 50,
    rx: 8,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.375 15.0416C38.7122 15.0416 39.9945 15.5728 40.94 16.5183C41.8855 17.4638 42.4167 18.7462 42.4167 20.0833C42.4167 21.4204 41.8855 22.7028 40.94 23.6483C39.9945 24.5938 38.7122 25.125 37.375 25.125C36.0379 25.125 34.7555 24.5938 33.81 23.6483C32.8645 22.7028 32.3334 21.4204 32.3334 20.0833C32.3334 18.7462 32.8645 17.4638 33.81 16.5183C34.7555 15.5728 36.0379 15.0416 37.375 15.0416ZM37.375 27.6458C42.9461 27.6458 47.4584 29.9019 47.4584 32.6875V35.2083H27.2917V32.6875C27.2917 29.9019 31.804 27.6458 37.375 27.6458Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg0Azul);
export default __webpack_public_path__ + "static/media/img0azul.91fffd6d0ef9576ec628eb6ef2bdc714.svg";
export { ForwardRef as ReactComponent };